import React, { useEffect, useState } from "react";
import PageTitle from "../../../module/pageTitle";
import AdminTable from "../../../Component/adminTable";
import LabelInput from "../../../Component/labelInput";
import { InputField, Submitbtn } from "../../../Component";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
import {
  deleteTagOption,
  getTagOptionList,
  updateTagOption,
} from "../adminSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
const EditDeleteTagOption = () => {
  const [isEditMode, setisEditMode] = useState<Boolean>(false);
  const [tagOptionList, setTagOptionList] = useState<any>([]);
  const [tagOption, setTagOption] = useState<any>("");
  const [order, setOrder] = useState<any>("");
  const [tagId, setTagId] = useState<any>("");

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    dispatch(
      getTagOptionList({
        callback: (res: any) => {
          setTagOptionList(res?.data);
        },
        errorCallback: () => { },
      })
    );
  };
  const handleGoBack = () => {
    setisEditMode(false);
  };
  const renderTable = () => {
    return (
      <div className="row bxshadow p-2 borderRadius">
        <AdminTable
          tableData={tagOptionList ? tagOptionList : []}
          pagename={"TagOption"}
          tableHead={["S.N", "Name", "Order No.", "Action"]}
          handleEdit={(value: any) => handleEdit(value)}
          handleDelete={(value: any) => handleDelete(value)}
          edit={true}
        />
      </div>
    );
  };

  const handleEdit = (value: any) => {
    setisEditMode(true);
    setTagId(value?._id);
    setTagOption(value?.name);
    setOrder(value?.order);
  };
  const handleDelete = (value: any) => {
    setisEditMode(false);
    dispatch(
      deleteTagOption({
        id: value._id,
        callback: (res: any) => {
          if (res?.status === "success") {
            getData();
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }))
            setTimeout(() => {
              dispatch(hideSnackbar());
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }))
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
      })
    );
  };

  const onchangeTagOption = (value: any) => {
    setTagOption(value);
  };
  const onchangeOrderNumber = (value: any) => {
    setOrder(value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData: any = {
      name: tagOption,
      order: order,
    };
    dispatch(
      updateTagOption({
        id: tagId,
        params: postData,
        callback: (res: any) => {
          setisEditMode(false);
          getData();
          if (res?.data?.status === "success") {

            dispatch(showSnackbar({ message: res?.data?.msg, type: res?.data?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };
  const validations = () => {
    return (
      tagOption === "" ||
      order === ""
    );
  };
  const renderEditMode = () => {
    return (
      <form onSubmit={handleSubmit}>
        <div className="row bxshadow p-2 borderRadius w-75">
          <div className="col-md-6 mb-3">
            <LabelInput labelName={"Tag Option"} isRequired />
            <InputField
              key={"ex2"}
              placeholder={"Enter Tag Option"}
              setInputText={(value: any) => onchangeTagOption(value)}
              value={tagOption}
            />
          </div>
          <div className="col-md-6 mb-3">
            <LabelInput labelName={"Order number"} isRequired />
            <InputField
              key={"ex2"}
              placeholder={"Enter Order number"}
              setInputText={(value: any) => onchangeOrderNumber(value)}
              value={order}
            />
          </div>
        </div>
        <div className="col-md-9 text-center my-3">
          <div className="col-md-3 mx-auto">
            <Submitbtn name={"Update"} disabled={validations()} />
          </div>
        </div>
      </form>
    );
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Edit / Delete Tag Option"}
          breadCrumb={""}
          isEditMode={isEditMode}
          setisEditMode={setisEditMode}
          cancelEdit={() => handleGoBack()}
        />
      </div>
      <div className="formDiv">
        {isEditMode ? renderEditMode() : renderTable()}
      </div>
    </div>
  );
};

export default EditDeleteTagOption;
